import type { CSSObject } from '@emotion/react';
import { useTheme } from '../../../theme';

type Return = Record<
  'container' | 'content' | 'iconContainer' | 'text' | 'title' | 'description',
  CSSObject
>;

type Props = {
  type: 'upgrade' | 'beta';
};

export const useFeatureCalloutStyles = ({ type }: Props): Return => {
  const theme = useTheme();

  return {
    container: {
      display: 'flex',
      padding: theme.spacing(4),
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      gap: theme.spacing(3),
      flexWrap: 'wrap',
      borderRadius: theme.shape.radius8,
      backgroundColor:
        type === 'upgrade' ? theme.callout.upgrade : theme.callout.beta,
    },
    content: {
      display: 'flex',
      minWidth: 239,
      alignItems: 'flex-start',
      gap: theme.spacing(3),
      flex: '1 0 0',
    },
    iconContainer: {
      display: 'flex',
      padding: theme.spacing(2),
      alignItems: 'flex-start',
      gap: theme.spacing(2),
      borderRadius: theme.shape.radius8,
      background:
        type === 'upgrade'
          ? theme.subscription.upgradeIcon.background
          : theme.beta.icon.background,
    },
    text: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
      flex: '1 0 0',
    },
    title: {
      alignsSelf: 'stretch',
      color: theme.text.generic.primary,
    },
    description: {
      color: theme.text.generic.secondary,
    },
  };
};
